import type { UIProfile } from "../../pages/stores/startupConfiguration"
import { IFrameEvents } from "./IFrameEvents"
import { createParentMessenger } from "./WindowMessenger"

type LanguageLineEvent = {
  type:
    | "LLS.Telehealth.Connected"
    | "LLS.Telehealth.Connecting"
    | "LLS.Telehealth.Disconnected"
    | "LLS.Telehealth.ConnectFailed"
  callId: string | undefined
  reason?: string
}

export const initLanguageLineIFrameEvents = (
  uiProfile: UIProfile
): IFrameEvents => {
  // eslint-disable-next-line no-console
  console.log("Initializing LanguageLine IFrame Events")

  const { postMessage } = createParentMessenger<LanguageLineEvent>(uiProfile)

  return {
    onSessionConnecting: ({ conferenceId }) =>
      postMessage({ type: "LLS.Telehealth.Connecting", callId: conferenceId }),
    onSessionConnected: ({ conferenceId }) =>
      postMessage({ type: "LLS.Telehealth.Connected", callId: conferenceId }),
    onSessionDisconnected: ({ conferenceId }) =>
      postMessage({
        type: "LLS.Telehealth.Disconnected",
        callId: conferenceId,
      }),
    onSessionConnectFailed: ({ conferenceId, reason }) =>
      postMessage({
        type: "LLS.Telehealth.ConnectFailed",
        callId: conferenceId,
        reason: reason || "Connect failed due to an unexpected error",
      }),
  }
}
